import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_jumbotron = _resolveComponent("b-jumbotron")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_b_jumbotron, { "bg-variant": "white" }, {
      header: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("authenticationError.authenticationError")), 1)
      ]),
      lead: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("authenticationError.warning")), 1)
      ]),
      default: _withCtx(() => [
        _cache[0] || (_cache[0] = _createElementVNode("hr", { class: "my-4" }, null, -1)),
        _createVNode(_component_b_button, {
          variant: "primary",
          class: "my-2 my-sm-0",
          type: "button",
          onClick: _ctx.handleClick
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("authenticationError.home")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    })
  ]))
}